// Painting pricing — extracted VERBATIM from the legacy RequestWizard estimate logic.
// Do not change values here without explicit product approval (pricing parity requirement).

// Price ranges based on specific answers (not just category)
const ANSWER_PRICE_RANGES = {
  // Painting type selections - base price before item selection
  painting_type: {
    interior: { low: 0, high: 0 }, // Will be calculated from room_types
    exterior: { low: 1500, high: 8000 },
    specialty: { low: 800, high: 5000 }
  },
  // Interior room counts - no longer used for pricing, just for info
  interior_rooms: {
    "1-2": { low: 0, high: 0 },
    "3-4": { low: 0, high: 0 },
    "5+": { low: 0, high: 0 }
  },
  // Exterior type
  exterior_type: {
    partial: { low: 500, high: 2000 },
    full_house: { low: 2000, high: 8000 },
    standalone: { low: 150, high: 500 },
    specialty: { low: 1000, high: 5000 }
  },
  // Project size (generic)
  project_size: {
    small: { low: 150, high: 500 },
    medium: { low: 400, high: 1500 },
    large: { low: 1000, high: 5000 }
  },
  // Ceiling height modifiers
  interior_ceiling_height: {
    standard: { low: 0, high: 0 },
    high: { low: 100, high: 300 },
    very_high: { low: 200, high: 600 }
  },
  // Stories modifier
  stories: {
    "1": { low: 0, high: 0 },
    "2+": { low: 200, high: 800 }
  }
};

// ==================== INTERIOR PAINTING PRICES (REVISED) ====================

// Bedroom prices
const BEDROOM_PRICES = {
  master_bedroom: { low: 525, high: 800, label: "Master Bedroom" },
  secondary_bedroom: { low: 375, high: 575, label: "Secondary Bedroom" },
  additional_bedroom: { low: 325, high: 500, label: "Additional Bedroom (3rd+)" }
};

// Bathroom prices
const BATHROOM_PRICES = {
  bathroom: { low: 325, high: 650, label: "Bathroom (walls + ceiling)" }
};

// Closet prices
const CLOSET_PRICES = {
  master_closet: { low: 225, high: 450, label: "Master Closet" },
  additional_closet: { low: 175, high: 325, label: "Additional Closet" },
  pantry_linen: { low: 250, high: 550, label: "Pantry / Linen Closet (shelves included)" }
};

// Ceilings & Specialty (per sqft)
const CEILING_PRICES = {
  ceiling_paint_per_sqft: { low: 1.75, high: 3.00 }, // per sqft
  popcorn_removal: { low: 1800, high: 3800, label: "Popcorn Ceiling Removal" } // flat rate
};

// Trim, Doors & Detail Work
const TRIM_PRICES = {
  baseboards_per_sqft: { low: 1.25, high: 2.00 }, // per sqft
  crown_molding_per_sqft: { low: 1.75, high: 2.75 }, // per sqft
  interior_door: { low: 175, high: 250, label: "Interior Door (6-panel, 24\"–34\")" },
  door_trim_per_side: { low: 35, high: 50 } // per side
};

// Kitchen & Cabinet Painting
const CABINET_PRICES = {
  kitchen_cabinets: { low: 2200, high: 5500, label: "Kitchen Cabinets (full repaint)" },
  cabinet_hardware: { low: 18, high: 30 } // per cabinet
};

// Fixtures & Hardware Installation
const FIXTURE_INSTALL_PRICES = {
  replace_interior_door: { low: 75, high: 125, label: "Replace Interior Door" },
  replace_hinges_knobs: { low: 40, high: 60, label: "Replace Hinges & Knobs (per door)" },
  front_door_knob: { low: 95, high: 150, label: "Front Door Entry Knob" },
  sliding_glass_door: { low: 700, high: 1800, label: "Sliding Glass Door Replacement" }
};

// Electrical / Bath Fixtures
const ELECTRICAL_FIXTURE_PRICES = {
  ceiling_fan: { low: 225, high: 400, label: "Ceiling Fan (remove & install)" },
  install_vanity: { low: 325, high: 650, label: "Install Vanity" },
  install_faucet: { low: 150, high: 275, label: "Install Faucet" },
  bathroom_light: { low: 100, high: 175, label: "Bathroom Light Fixture" },
  kitchen_living_light: { low: 125, high: 275, label: "Kitchen / Living / Hall Fixture" },
  gfci_outlet: { low: 150, high: 400, label: "Install GFCI / Outlet" }
};

// Flooring (LVP)
const FLOORING_PRICES = {
  lvp_floating_per_sqft: { low: 2.50, high: 4.00 }, // Snap / Floating per sqft
  lvp_thinset_per_sqft: { low: 3.50, high: 5.00 } // Thinset & Grout per sqft
};

// Legacy room prices (keeping for backward compatibility with existing wizard)
const ROOM_PRICES = {
  // Bedrooms - REVISED
  all_bedrooms: { low: 525 + 375 + 325, high: 800 + 575 + 500, label: "All Bedrooms (avg 3)" },
  master_bedroom: { low: 525, high: 800, label: "Master Bedroom" },
  second_bedroom: { low: 375, high: 575, label: "Second Bedroom" },
  third_bedroom: { low: 325, high: 500, label: "Third Bedroom" },
  
  // Bathrooms - REVISED
  all_bathrooms: { low: 325 * 2, high: 650 * 2, label: "All Bathrooms (avg 2)" },
  master_bathroom: { low: 325, high: 650, label: "Master Bathroom" },
  second_bathroom: { low: 325, high: 650, label: "Second Bathroom" },
  third_bathroom: { low: 325, high: 650, label: "Third Bathroom" }
};

// Interior painting additional items - REVISED
const INTERIOR_ITEM_PRICES = {
  master_closet: { low: 225, high: 450, label: "Master Closet" },
  additional_closet: { low: 175, high: 325, label: "Additional Closet" },
  pantry_linen: { low: 250, high: 550, label: "Pantry / Linen Closet (shelves included)" },
  ceilings: { low: 1800, high: 3800, label: "Ceiling Paint (whole house)" }, // Will be calculated per sqft
  bathroom_vanity: { low: 325, high: 650, label: "Install Vanity" },
  baseboards: { low: 1250, high: 2500, label: "Baseboards (Entire House)" }, // Will be per sqft
  crown_molding: { low: 1750, high: 2750, label: "Crown Molding (Entire House)" }, // Will be per sqft
  doors: { low: 175, high: 250, label: "Interior Door (per door)" },
  kitchen_cabinets: { low: 2200, high: 5500, label: "Kitchen Cabinet Painting" }
};

// Popcorn ceiling removal - REVISED (flat rate now)
const POPCORN_AREA_PERCENTAGES = {
  entire_house: 1.0,      // 100%
  living_room: 0.30,      // 30%
  bedrooms: 0.40,         // 40%
  kitchen: 0.15,          // 15%
  bathrooms: 0.10         // 10%
};
const POPCORN_PRICE_PER_SQFT = { low: 1.50, high: 3.50 };

/**
 * Calculate the painting estimate exactly as the legacy wizard did.
 * @param {Object} answers - wizard answers
 * @param {number} homeSqftValue - resolved home square footage (default 1500)
 * @returns {{low: number, high: number} | null} null until a priceable answer exists
 */
export const calculatePaintingEstimate = (answers, homeSqftValue = 1500) => {
  let totalLow = 0;
  let totalHigh = 0;
  let hasValidPrice = false;

    // Check for painting-specific answers
    const paintingType = answers.painting_type;
    if (paintingType) {
      // For interior painting, calculate based on selected items
      if (paintingType === 'interior') {
        const selectedItems = answers.room_types || [];
        
        if (selectedItems.length > 0) {
          hasValidPrice = true;
          
          // Calculate bedroom prices
          if (selectedItems.includes('bedrooms')) {
            const selectedBedrooms = answers.which_bedrooms || [];
            if (selectedBedrooms.includes('all_bedrooms')) {
              totalLow += ROOM_PRICES.all_bedrooms.low;
              totalHigh += ROOM_PRICES.all_bedrooms.high;
            } else {
              // Add individual bedroom prices
              if (selectedBedrooms.includes('master_bedroom')) {
                totalLow += ROOM_PRICES.master_bedroom.low;
                totalHigh += ROOM_PRICES.master_bedroom.high;
              }
              if (selectedBedrooms.includes('second_bedroom')) {
                totalLow += ROOM_PRICES.second_bedroom.low;
                totalHigh += ROOM_PRICES.second_bedroom.high;
              }
              if (selectedBedrooms.includes('third_bedroom')) {
                totalLow += ROOM_PRICES.third_bedroom.low;
                totalHigh += ROOM_PRICES.third_bedroom.high;
              }
              // Extra bedrooms (4th+) at $325-$500 each
              if (selectedBedrooms.includes('more_bedrooms') && answers.extra_bedrooms_count) {
                const extraCount = answers.extra_bedrooms_count === '4+' ? 4 : parseInt(answers.extra_bedrooms_count);
                totalLow += BEDROOM_PRICES.additional_bedroom.low * extraCount;
                totalHigh += BEDROOM_PRICES.additional_bedroom.high * extraCount;
              }
            }
          }
          
          // Calculate bathroom prices ($325-$650 each)
          if (selectedItems.includes('bathrooms')) {
            const selectedBathrooms = answers.which_bathrooms || [];
            if (selectedBathrooms.includes('all_bathrooms')) {
              totalLow += ROOM_PRICES.all_bathrooms.low;
              totalHigh += ROOM_PRICES.all_bathrooms.high;
            } else {
              if (selectedBathrooms.includes('master_bathroom')) {
                totalLow += BATHROOM_PRICES.bathroom.low;
                totalHigh += BATHROOM_PRICES.bathroom.high;
              }
              if (selectedBathrooms.includes('second_bathroom')) {
                totalLow += BATHROOM_PRICES.bathroom.low;
                totalHigh += BATHROOM_PRICES.bathroom.high;
              }
              if (selectedBathrooms.includes('third_bathroom')) {
                totalLow += BATHROOM_PRICES.bathroom.low;
                totalHigh += BATHROOM_PRICES.bathroom.high;
              }
              // Extra bathrooms (4th+)
              if (selectedBathrooms.includes('more_bathrooms') && answers.extra_bathrooms_count) {
                const extraCount = answers.extra_bathrooms_count === '3+' ? 3 : parseInt(answers.extra_bathrooms_count);
                totalLow += BATHROOM_PRICES.bathroom.low * extraCount;
                totalHigh += BATHROOM_PRICES.bathroom.high * extraCount;
              }
            }
          }
          
          // Calculate closet prices
          if (selectedItems.includes('master_closet')) {
            totalLow += CLOSET_PRICES.master_closet.low;
            totalHigh += CLOSET_PRICES.master_closet.high;
          }
          if (selectedItems.includes('additional_closet') && answers.additional_closet_count) {
            const closetCount = answers.additional_closet_count === '4+' ? 4 : parseInt(answers.additional_closet_count);
            totalLow += CLOSET_PRICES.additional_closet.low * closetCount;
            totalHigh += CLOSET_PRICES.additional_closet.high * closetCount;
          }
          if (selectedItems.includes('pantry_linen')) {
            totalLow += CLOSET_PRICES.pantry_linen.low;
            totalHigh += CLOSET_PRICES.pantry_linen.high;
          }
          
          // Calculate door prices
          if (selectedItems.includes('doors') && answers.door_count) {
            let doorCount;
            switch (answers.door_count) {
              case '1-3': doorCount = 2; break;
              case '4-6': doorCount = 5; break;
              case '7-10': doorCount = 8; break;
              case '10+': doorCount = 12; break;
              default: doorCount = 1;
            }
            totalLow += TRIM_PRICES.interior_door.low * doorCount;
            totalHigh += TRIM_PRICES.interior_door.high * doorCount;
          }
          
          // Calculate popcorn ceiling removal - REVISED to flat rate $1,800-$3,800
          if (selectedItems.includes('popcorn_removal')) {
            totalLow += CEILING_PRICES.popcorn_removal.low;
            totalHigh += CEILING_PRICES.popcorn_removal.high;
          }
          
          // Calculate ceiling paint based on sqft ($1.75-$3.00/sqft)
          if (selectedItems.includes('ceilings')) {
            totalLow += homeSqftValue * CEILING_PRICES.ceiling_paint_per_sqft.low;
            totalHigh += homeSqftValue * CEILING_PRICES.ceiling_paint_per_sqft.high;
          }
          
          // Calculate baseboards based on sqft ($1.25-$2.00/sqft)
          if (selectedItems.includes('baseboards')) {
            totalLow += homeSqftValue * TRIM_PRICES.baseboards_per_sqft.low;
            totalHigh += homeSqftValue * TRIM_PRICES.baseboards_per_sqft.high;
          }
          
          // Calculate crown molding based on sqft ($1.75-$2.75/sqft)
          if (selectedItems.includes('crown_molding')) {
            totalLow += homeSqftValue * TRIM_PRICES.crown_molding_per_sqft.low;
            totalHigh += homeSqftValue * TRIM_PRICES.crown_molding_per_sqft.high;
          }
          
          // Kitchen cabinets - flat rate
          if (selectedItems.includes('kitchen_cabinets')) {
            totalLow += CABINET_PRICES.kitchen_cabinets.low;
            totalHigh += CABINET_PRICES.kitchen_cabinets.high;
          }
        }
        
        // Add ceiling height adjustments
        if (answers.interior_ceiling_height) {
          const ceilingRange = ANSWER_PRICE_RANGES.interior_ceiling_height[answers.interior_ceiling_height];
          if (ceilingRange) {
            totalLow += ceilingRange.low;
            totalHigh += ceilingRange.high;
          }
        }
        
        // Add stories adjustments
        if (answers.stories) {
          const storiesRange = ANSWER_PRICE_RANGES.stories[answers.stories];
          if (storiesRange) {
            totalLow += storiesRange.low;
            totalHigh += storiesRange.high;
          }
        }
        
        // ==================== ADDITIONAL SERVICES PRICING ====================
        const additionalServices = answers.additional_services || [];
        
        // Fixtures & Hardware Installation
        if (additionalServices.includes('fixtures_hardware')) {
          const fixtureItems = answers.fixtures_hardware_items || [];
          
          if (fixtureItems.includes('replace_interior_door')) {
            totalLow += FIXTURE_INSTALL_PRICES.replace_interior_door.low;
            totalHigh += FIXTURE_INSTALL_PRICES.replace_interior_door.high;
          }
          if (fixtureItems.includes('replace_hinges_knobs')) {
            let doorCount = 1;
            switch (answers.door_hardware_count) {
              case '1-2': doorCount = 1.5; break;
              case '3-5': doorCount = 4; break;
              case '6+': doorCount = 7; break;
            }
            totalLow += FIXTURE_INSTALL_PRICES.replace_hinges_knobs.low * doorCount;
            totalHigh += FIXTURE_INSTALL_PRICES.replace_hinges_knobs.high * doorCount;
          }
          if (fixtureItems.includes('front_door_knob')) {
            totalLow += FIXTURE_INSTALL_PRICES.front_door_knob.low;
            totalHigh += FIXTURE_INSTALL_PRICES.front_door_knob.high;
          }
          if (fixtureItems.includes('sliding_glass_door')) {
            totalLow += FIXTURE_INSTALL_PRICES.sliding_glass_door.low;
            totalHigh += FIXTURE_INSTALL_PRICES.sliding_glass_door.high;
          }
        }
        
        // Electrical / Bath Fixtures
        if (additionalServices.includes('electrical_bath')) {
          const electricalItems = answers.electrical_bath_items || [];
          
          if (electricalItems.includes('ceiling_fan')) {
            let fanCount = 1;
            switch (answers.ceiling_fan_count) {
              case '1': fanCount = 1; break;
              case '2': fanCount = 2; break;
              case '3+': fanCount = 3; break;
            }
            totalLow += ELECTRICAL_FIXTURE_PRICES.ceiling_fan.low * fanCount;
            totalHigh += ELECTRICAL_FIXTURE_PRICES.ceiling_fan.high * fanCount;
          }
          if (electricalItems.includes('install_vanity')) {
            totalLow += ELECTRICAL_FIXTURE_PRICES.install_vanity.low;
            totalHigh += ELECTRICAL_FIXTURE_PRICES.install_vanity.high;
          }
          if (electricalItems.includes('install_faucet')) {
            totalLow += ELECTRICAL_FIXTURE_PRICES.install_faucet.low;
            totalHigh += ELECTRICAL_FIXTURE_PRICES.install_faucet.high;
          }
          if (electricalItems.includes('bathroom_light') || electricalItems.includes('kitchen_living_light')) {
            let fixtureCount = 1;
            switch (answers.light_fixture_count) {
              case '1-2': fixtureCount = 1.5; break;
              case '3-5': fixtureCount = 4; break;
              case '6+': fixtureCount = 7; break;
            }
            const avgLow = (ELECTRICAL_FIXTURE_PRICES.bathroom_light.low + ELECTRICAL_FIXTURE_PRICES.kitchen_living_light.low) / 2;
            const avgHigh = (ELECTRICAL_FIXTURE_PRICES.bathroom_light.high + ELECTRICAL_FIXTURE_PRICES.kitchen_living_light.high) / 2;
            totalLow += avgLow * fixtureCount;
            totalHigh += avgHigh * fixtureCount;
          }
          if (electricalItems.includes('gfci_outlet')) {
            let outletCount = 1;
            switch (answers.outlet_count) {
              case '1': outletCount = 1; break;
              case '2-3': outletCount = 2.5; break;
              case '4+': outletCount = 5; break;
            }
            totalLow += ELECTRICAL_FIXTURE_PRICES.gfci_outlet.low * outletCount;
            totalHigh += ELECTRICAL_FIXTURE_PRICES.gfci_outlet.high * outletCount;
          }
        }
        
        // Flooring (LVP)
        if (additionalServices.includes('flooring_lvp')) {
          const flooringAreas = answers.flooring_area || [];
          let flooringSqft = 0;
          
          // Calculate area based on selection
          if (flooringAreas.includes('entire_house')) {
            flooringSqft = homeSqftValue;
          } else {
            if (flooringAreas.includes('living_areas')) flooringSqft += homeSqftValue * 0.35;
            if (flooringAreas.includes('bedrooms')) flooringSqft += homeSqftValue * 0.30;
            if (flooringAreas.includes('kitchen')) flooringSqft += homeSqftValue * 0.15;
            if (flooringAreas.includes('bathrooms')) flooringSqft += homeSqftValue * 0.10;
          }
          
          if (flooringSqft > 0 && answers.flooring_type) {
            if (answers.flooring_type === 'lvp_floating') {
              totalLow += flooringSqft * FLOORING_PRICES.lvp_floating_per_sqft.low;
              totalHigh += flooringSqft * FLOORING_PRICES.lvp_floating_per_sqft.high;
            } else if (answers.flooring_type === 'lvp_thinset') {
              totalLow += flooringSqft * FLOORING_PRICES.lvp_thinset_per_sqft.low;
              totalHigh += flooringSqft * FLOORING_PRICES.lvp_thinset_per_sqft.high;
            }
          }
        }
        // ==================== END ADDITIONAL SERVICES PRICING ====================
      }
      
      // For exterior painting, use the existing pricing
      if (paintingType === 'exterior') {
        const range = ANSWER_PRICE_RANGES.painting_type[paintingType];
        totalLow += range.low;
        totalHigh += range.high;
        hasValidPrice = true;
        
        if (answers.exterior_type) {
          const exteriorRange = ANSWER_PRICE_RANGES.exterior_type[answers.exterior_type];
          if (exteriorRange) {
            totalLow += exteriorRange.low;
            totalHigh += exteriorRange.high;
          }
        }
      }
      
      // For specialty painting
      if (paintingType === 'specialty') {
        const range = ANSWER_PRICE_RANGES.painting_type[paintingType];
        totalLow += range.low;
        totalHigh += range.high;
        hasValidPrice = true;
      }
    }

  if (!hasValidPrice) return null;
  return { low: totalLow, high: totalHigh };
};
